import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../pages/Auth/authSelectors";
import dayjs from "dayjs";

export function useTxLock() {
  const authInfo = useSelector(selectAuthInfo);

  const lockDate = authInfo?.transaction_lock_date ?? null; // "YYYY-MM-DD" or null

  const lockDateFormatted = useMemo(
    () => (lockDate ? dayjs(lockDate).format("DD-MMM-YYYY") : null),
    [lockDate]
  );
console.log(lockDateFormatted,'lockDateFormatted');
  const isLocked = useMemo(() => {
    return (transactionDate) => {
      if (!lockDate || !transactionDate) return false;
      return !dayjs(transactionDate).startOf("day").isAfter(dayjs(lockDate).startOf("day"));
    };
  }, [lockDate]);

  return { isLocked, lockDate, lockDateFormatted };
}